import { GuestReservation, GuestReservationChange } from '../models/Order';

// What the guest picked on the reservation page: a date, a party and a time on that date
export interface ReservationDraft {
  dateKey: string;
  partySize: number;
  time?: string;
}

// The change to send: only what differs from the reservation; undefined until a time is picked or when nothing
// changed. A new date or party needs a time picked again (the old one may not be free).
export function reservationChange(current: GuestReservation, draft: ReservationDraft): GuestReservationChange | undefined {
  if (!draft.time) {
    return undefined;
  }
  const change: GuestReservationChange = {};
  if (draft.dateKey !== current.date_key) {
    change.date_key = draft.dateKey;
  }
  if (draft.partySize !== current.party_size) {
    change.party_size = draft.partySize;
  }
  if (draft.time !== current.time) {
    change.time = draft.time;
  }
  return Object.keys(change).length > 0 ? change : undefined;
}

// The party sizes the guest can choose: the limits of the venue's booking types, and never fewer than the children
export function partySizes(reservation: GuestReservation): number[] {
  const min = Math.max(reservation.min_party_size ?? 1, reservation.children_count, 1);
  const max = Math.max(reservation.max_party_size ?? reservation.party_size, reservation.party_size, min);
  return Array.from({ length: max - min + 1 }, (_, i) => min + i);
}

// The times to show: the free ones, with the reservation's own time when it is on the same date with the same party
// (its own table counts as free, so samwise has it, unless the time has closed since)
export function timesToShow(current: GuestReservation, draft: ReservationDraft, free: string[]): string[] {
  const own = draft.dateKey === current.date_key && draft.partySize === current.party_size;
  const times = own && !free.includes(current.time) ? [...free, current.time] : [...free];
  return times.sort();
}
